module.exports = __webpack_public_path__ + "static/media/icon-sc.326ad14f.svg";